import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Clock3, ThumbsDown, ThumbsUp } from 'lucide-react'
import TeamAvatar from './TeamAvatar'
import { useTeamStore } from '../store/useTeamStore'
import { formatAgo } from '../../profile/utils/profileFormat'
import { formatSecondsLeft } from '../../../utils/formatters'
import { CARD_CLASS } from '../utils/teamUi'
import { hapticImpact } from '../../../utils/haptic'

const RecentLeftTeams = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { recentLeft, recentLeftReceivedAt } = useTeamStore()
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [])
  const active = recentLeft.filter((entry) => entry.vote_ends_in > Math.max(0, (now - recentLeftReceivedAt) / 1000) && entry.team?.slug)
  if (!active.length) return null
  const reasons = {
    kick: t('team.recentLeft.kick'),
    leave: t('team.recentLeft.leave'),
    admin: t('team.recentLeft.admin')
  }
  return <div className={`${CARD_CLASS} space-y-2 p-4`}>
    <h2 className="text-sm font-bold not-italic text-white">{t('team.recentLeft.title')}</h2>
    <p className="text-xs text-text-secondary">{t('team.recentLeft.hint')}</p>
    {active.map((entry) => {
      const remaining = Math.max(0, Math.ceil(entry.vote_ends_in - (now - recentLeftReceivedAt) / 1000))
      return <button key={entry.team.slug} type="button" onClick={() => { hapticImpact('light'); navigate(`/teams/${entry.team.slug}`) }} className="flex w-full items-center gap-3 rounded-xl border border-white/10 bg-dark-primary p-3 text-left active:scale-[0.98]">
        <TeamAvatar team={entry.team} size={40} />
        <span className="min-w-0 flex-1"><span className="block truncate text-sm font-semibold text-white">{entry.team.name}</span><span className="block text-[11px] text-text-secondary">{reasons[entry.reason] || reasons.leave} · {formatAgo(entry.ago + Math.floor((now - recentLeftReceivedAt) / 1000), t)}</span><span className="flex items-center gap-1 text-[11px] text-text-secondary"><Clock3 size={11} />{t('team.recentLeft.voteLeft', { time: formatSecondsLeft(remaining, t) })}</span>{!entry.can_vote && <span className="text-[11px] text-text-secondary">{t('team.recentLeft.depositRequired')}</span>}</span>
        {entry.my_vote === 1 ? <ThumbsUp size={16} className="text-accent-primary" /> : entry.my_vote === -1 ? <ThumbsDown size={16} className="text-red-400" /> : null}
      </button>
    })}
  </div>
}

export default RecentLeftTeams
